import { Button } from "./ui/button";
import { Minus, Plus, Trash2 } from "lucide-react";
import { formatRupiah } from "../lib/format";

const CartItemRow = ({ item, onDec, onInc, onRemove, compact = false }) => {
  return (
    <li
      className={`flex items-center gap-3 ${compact ? "py-3" : "py-4"}`}
      data-testid={`cart-row-${item.productId}`}
    >
      <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-xl overflow-hidden bg-stone-100 shrink-0">
        <img
          src={item.image}
          alt={item.productName}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-medium text-stone-900 truncate">{item.productName}</p>
        <p className="text-sm text-stone-500">{formatRupiah(item.price)}</p>
        <p className="font-semibold text-emerald-700 mt-0.5">
          {formatRupiah(item.subtotal)}
        </p>
      </div>
      <div className="flex flex-col items-end gap-2 shrink-0">
        <div className="flex items-center gap-1 bg-stone-50 border border-stone-200 rounded-full p-1">
          <Button
            type="button"
            size="icon"
            variant="ghost"
            className="h-8 w-8 text-stone-700 rounded-full"
            onClick={onDec}
            data-testid={`cart-row-dec-${item.productId}`}
            aria-label="Kurangi"
          >
            <Minus className="w-4 h-4" />
          </Button>
          <span className="w-6 text-center font-semibold text-stone-900">
            {item.quantity}
          </span>
          <Button
            type="button"
            size="icon"
            variant="ghost"
            className="h-8 w-8 text-stone-700 rounded-full"
            onClick={onInc}
            data-testid={`cart-row-inc-${item.productId}`}
            aria-label="Tambah"
          >
            <Plus className="w-4 h-4" />
          </Button>
        </div>
        <button
          type="button"
          onClick={onRemove}
          className="text-rose-600 hover:text-rose-700 text-sm inline-flex items-center gap-1"
          data-testid={`cart-row-remove-${item.productId}`}
        >
          <Trash2 className="w-3.5 h-3.5" /> Hapus
        </button>
      </div>
    </li>
  );
};

export default CartItemRow;
